import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  /** CTA — pass a <Button/>. BRIEF: never a blank div. */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center px-6 py-16 text-center', className)}>
      {icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-grey-100 text-grey-400 [&>svg]:h-6 [&>svg]:w-6">
          {icon}
        </div>
      )}
      <h3 className="text-heading-4 text-secondary">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-body-sm text-grey-500">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
